<mat-card class="matp-card">
  <app-shipment-info-preparation-table
    tableIdPrefix="shipment-info-ready"
    [shipmentList]="shipmentList"
    (opened)="opened.emit($event)"
  ></app-shipment-info-preparation-table>
</mat-card>
